import { Editor, Range, Transforms } from 'slate'
import { isKeyHotkey } from 'is-hotkey'
import React from 'react'

import LinkPlugin from './LinkPlugin'
import RawInterpolationPlugin from './RawInterpolationPlugin'

export const useEditorKeydown = editor => {
  const onKeyDown = React.useCallback(e => {
    const { selection } = editor

    if (
      selection &&
      Range.isCollapsed(selection) &&
      (LinkPlugin.isActive(editor) || RawInterpolationPlugin.isActive(editor))
    ) {
      const { nativeEvent } = e
      if (isKeyHotkey('left', nativeEvent)) {
        e.preventDefault()
        Transforms.move(editor, { unit: 'offset', reverse: true })
        return
      }
      if (isKeyHotkey('right', nativeEvent)) {
        e.preventDefault()
        Transforms.move(editor, { unit: 'offset' })
        return
      }
    }

    if (editor.singleLine) {
      if (isKeyHotkey('enter', e.nativeEvent)) {
        e.preventDefault()
        return
      }
    }

    if (editor.numbers) {
      const allowedKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', 'left', 'right', 'backspace']
      if (!isKeyHotkey(allowedKeys, e.nativeEvent)) {
        e.preventDefault()
        return
      }
    }

    if (editor.singleItem) {
      const allowedKeys = ['left', 'right', 'backspace', 'delete']
      if (!isKeyHotkey(allowedKeys, e.nativeEvent)) {
        e.preventDefault()
        return
      }
    }

    // if (e.code === 'Enter') {
    // const [match] = Array.from(
    // Editor.nodes(editor, {
    // at: Editor.unhangRange(editor, selection),
    // match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === 'image'
    // })
    // )

    // if (!!match) {
    // const newLine = { type: 'paragraph', children: [{ text: '' }] }
    // Transforms.insertNodes(editor, newLine)
    // }
    // }

    if (e.code === 'Tab') {
      e.preventDefault()
      Editor.insertText(editor, '  ')
      return
    }
  }, [])

  return onKeyDown
}
